import React from "react";
import { Box, Typography, Avatar, Paper, Rating, Button } from "@mui/material";
import img1 from "../../assets/Minerva.webp";
import img2 from "../../assets/ghee_customer_Moment.webp";
import img3 from "../../assets/Untitled_2_489afb6b.jpg";

const testimonials = [
  {
    name: "Ramesh Gowda",
    review:
      "I recently booked a plot in Kalpavruksha Green, and I’m very happy with how transparent and professional the entire team was. The location and amenities are excellent!",
    image: img1,
  },
  {
    name: "Anita Sharma",
    review:
      "Nava Karnataka Nirmana & Others Housing Welfare Trust truly delivers what they promise. The process was smooth, and the staff helped with all documentation and details patiently.",
    image: img2,
  },
  {
    name: "Vikram Reddy",
    review:
      "I was impressed by their commitment to quality and community development. Vaibhava Greens is a peaceful and well-planned layout — perfect for families like ours.",
    image: img3,
  },
];

const Testimonials = () => {
  return (
    <Box>
      <Box
        sx={{
          background:
            "linear-gradient(to right, rgba(226, 255, 255, 0.26), rgba(0, 180, 194, 0.16))",
          py: 6,
          px: 2,
        }}
      >
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: 700, color: "#008037", mb: 5 }}
          >
            What Do Our Customers Say
          </Typography>

          {/* Force cards into a horizontal row */}
          <Box
            sx={{
              display: "flex",
              gap: 4,
              flexWrap: { xs: "nowrap", md: "wrap" },
              overflowX: { xs: "auto", md: "visible" },
              scrollbarWidth: "none",
              px: { xs: 1, md: 0 },
            }}
          >
            {testimonials.map((item, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  border: "1px solid #00695c",
                  borderRadius: "12px",
                  padding: "24px",
                  width: 320,
                  backgroundColor: "#2c5e5f",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 14,
                    color: "white",
                    mb: 1.5,
                    lineHeight: 1.2,
                  }}
                >
                  {item.review}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 2,
                    mt: 0.5,
                  }}
                >
                  <Avatar src={item.image} sx={{ width: 60, height: 60 }} />

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 700, color: "white" }}
                    >
                      {item.name}
                    </Typography>
                    <Rating value={5} readOnly sx={{ color: "#ffc107" }} />
                  </Box>
                </Box>
              </Paper>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonials;
